import { useMutation } from "@tanstack/react-query";
import { login, logout, refresh } from "./service";

/**
 * auth
 */

export const useLogin = () =>
    useMutation({
        mutationKey: ['login'],
        mutationFn: ({ id, password }) => login({ id, password }),
    })

export const useLogout = () => 
    useMutation({
        mutationKey: ['logout'],
        mutationFn: logout,
    })

export const useRefresh = () => 
    useMutation({
        mutationKey: ['refresh'],
        mutationFn: refresh,
    })